import { render } from "./ClientsDetails.vue?vue&type=template&id=4ba7d468&scoped=true"
import script from "./ClientsDetails.vue?vue&type=script&lang=js"
export * from "./ClientsDetails.vue?vue&type=script&lang=js"

import "./ClientsDetails.vue?vue&type=style&index=0&id=4ba7d468&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba7d468"]])

export default __exports__